import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@docpath/linces-angular-components/common';
import { Table } from '@docpath/webcomponents/table';

import { EnginesHttpService } from '../../services/engines-http.service';
import { EnginesTableService } from './engines-table.service';

@Component({
    selector: 'app-engines-table',
    templateUrl: './engines-table.component.html'
})
export class EnginesTableComponent implements OnInit {

    @Input() filters: Filter[] = [];
    @Output() selectedRow = new EventEmitter<void>();
    @Output() tableLoaded = new EventEmitter<Table>();

    table: Table;
    showLoading = false;

    constructor(
        private readonly enginesTableService: EnginesTableService,
        private readonly enginesHttpService: EnginesHttpService
    ) {
        this.table = this.enginesTableService.initTable();
    }

    ngOnInit(): void {

        this.enginesTableService.dgesLoaded.subscribe(result => {
            this.table.header = this.enginesTableService.initTableHeader();
            this.table.body = this.enginesTableService.initTableBody(result);
        });

        this.enginesHttpService.showLoadingTableChanged.subscribe(showLoading => {
            this.showLoading = showLoading;
        });

        this.enginesTableService.loadDges([], 1, 25);
        this.tableLoaded.emit(this.table);
    }

    onChangeCheck(): void {
        this.selectedRow.emit();
    }

    onChangePage(page: number): void {
        this.enginesTableService.loadDges(this.filters, page);
    }

    onChangePageSize(size: number): void {
        this.enginesTableService.loadDges(this.filters, 1, size);
    }

    getCurrentPage(): number {
        return this.enginesTableService.getCurrentPage();
    }

    getCurrentSize(): number {
        return this.enginesTableService.getCurrentSize();
    }

    getElements(): number {
        return this.enginesTableService.getElements();
    }

}